import axios from 'axios'

const BASE_URL = process.env.VUE_APP_API_BASE_URL
const API_URL = BASE_URL + 'user'

let sourceGetUserListBasedOnQueries = axios.CancelToken.source()

class UserService {
  getUserCredential () {
    return axios.get(API_URL + '/generate-credential')
  }

  getCurrentUserData () {
    return axios.get(API_URL + '/current-user')
  }

  getUserById (userId) {
    return axios.get(API_URL + '/' + userId)
  }

  updateUserActiveStatus (userId, publishStatus) {
    return axios.post(API_URL + '/' + userId + '/change-status/' + publishStatus, null)
  }

  updateUserEmailNotificationStatus (userId, enableStatus) {
    return axios.post(API_URL + '/' + userId + '/change-email-notification-status/' + enableStatus, null)
  }

  updateCurrentUser (userData) {
    return axios.post(API_URL + '/update/current-user', userData)
  }

  updateUser (user) {
    return axios.post(API_URL + '/update', user)
  }

  changeCurrentUserPassword (resetUser) {
    return axios.post(API_URL + '/change-password/current-user', resetUser)
  }

  changeUserPassword (resetUser) {
    return axios.post(API_URL + '/reset-password', resetUser)
  }

  changeUserPasswordCRM (resetUser) {
    return axios.post(API_URL + '/change-user-password-crm', resetUser)
  }

  requestToPasswordChange (userEmail) {
    return axios.get(API_URL + '/password/forgot/admin/' + userEmail)
  }

  resetPassword (resetUser) {
    return axios.post(API_URL + '/password/reset/admin', resetUser)
  }

  checkUserIfExists (user) {
    return axios.post(API_URL + '/check-if-exists', user)
  }

  createEmployee (user) {
    return axios.post(API_URL + '/create-employee', user)
  }

  createMember (user) {
    return axios.post(API_URL + '/create-member', user)
  }

  createOrUpdateAdmin (user) {
    user.ReceiveEmailNotification = !user.ReceiveEmailNotification
    return axios.post(API_URL + '/create-or-update/admin', user)
  }

  createWalkInUser () {
    return axios.post(API_URL + '/create-walk-in-user')
  }

  getUserListBasedOnQueries (index, limit, searchKey, activeStatus, userTypes, filterObj = null) {
    index = index || 0
    limit = limit || 2147483647
    searchKey = searchKey || 'null'
    userTypes = userTypes || null
    activeStatus = activeStatus || 'All'
    var sortKey = 'FullName'
    var IsAscending = true
    var isAll = true
    var isAddedStudent = true
    var IsEverPurchased = true
    if (filterObj) {
      isAll = filterObj.isAll
      isAddedStudent = filterObj.isAddedNoStudent
      IsEverPurchased = filterObj.isNeverPurchased
    }

    sourceGetUserListBasedOnQueries.cancel('Previous Operation cancelled.')
    sourceGetUserListBasedOnQueries = axios.CancelToken.source()

    return axios.get(API_URL + '/list?index=' + index + '&limit=' + limit + '&sortKey=' + sortKey + '&IsAscending=' + IsAscending + '&searchKey=' + searchKey + '&activeStatus=' + activeStatus + '&userTypes=' + userTypes + '&isAll=' + isAll + '&isAddedStudent=' + isAddedStudent + '&IsEverPurchased=' + IsEverPurchased,
      { cancelToken: sourceGetUserListBasedOnQueries.token, showLoader: false }).catch(function (thrown) {
      if (axios.isCancel(thrown)) {
        return Promise.reject(thrown.message)
      } else {
        return Promise.reject(thrown)
      }
    })
  }

  getUserListBasedOnQueriesForSearch (index, limit, searchKey, activeStatus, userTypes) {
    index = index || 0
    limit = limit || 2147483647
    searchKey = searchKey || 'null'
    activeStatus = activeStatus || 'All'
    userTypes = userTypes || null

    sourceGetUserListBasedOnQueries.cancel('Previous Operation cancelled.')
    sourceGetUserListBasedOnQueries = axios.CancelToken.source()

    return axios.get(API_URL + '/search?index=' + index + '&limit=' + limit + '&searchKey=' + searchKey + '&activeStatus=' + activeStatus + '&userTypes=' + userTypes,
      { cancelToken: sourceGetUserListBasedOnQueries.token, showLoader: false }).catch(function (thrown) {
      if (axios.isCancel(thrown)) {
        return Promise.reject(thrown.message)
      } else {
        return Promise.reject(thrown)
      }
    })
  }

  getUserDefaultInformations (userType) {
    return axios.get(API_URL + '/default-address/' + userType)
  }

  updateDefaultCity (city) {
    return axios.post(API_URL + '/default/city?City=' + city)
  }

  updateDefaultState (state) {
    return axios.post(API_URL + '/default/state?State=' + state)
  }

  updateDefaultZip (zip) {
    return axios.post(API_URL + '/default/zip?Zip=' + zip)
  }

  getUsersBySupportGroupSessionId (sgSessionId) {
    return axios.get(API_URL + '/list/' + sgSessionId)
  }

  getAdminNoteById (userId) {
    return axios.get(API_URL + '/get-admin-notes/' + userId)
  }

  updateAdminNote (userId, adminNote) {
    var data = { userId: userId, adminNote: adminNote }
    return axios.post(API_URL + '/update-admin-note', data)
  }

  addAdminNote (userId, adminNote) {
    var data = { UserId: userId, Note: adminNote }
    return axios.post(API_URL + '/add-admin-note', data)
  }

  removeUser (Id) {
    return axios.delete(API_URL + '/' + Id + '/remove')
  }

  mergeUser (selectedUserId, mergeUserId) {
    var data = { selectedUserId: selectedUserId, mergeUserId: mergeUserId }
    return axios.post(API_URL + '/merge-user', data)
  }

  getUserCountBasedOnDuration (duration) {
    return axios.get(API_URL + '/count/' + duration, { showLoader: false })
  }

  refreshAdminUserAccessToken () {
    const portalName = 'Admin'
    return axios.post(API_URL + '/' + portalName + '/refresh-token', null)
  }

  getAdminUserDetailsById (UserID) {
    return axios.get(API_URL + '/' + UserID)
  }

  // Manage Child
  getChildsByUser (userId) {
    return axios.get(API_URL + '/' + userId + '/childs', { showLoader: false })
  }

  removeChildInformation (childId) {
    return axios.delete(API_URL + '/child/' + childId + '/remove')
  }

  saveChildInformation (child, userId) {
    var data = {
      child: child,
      userId: userId
    }
    return axios.post(API_URL + '/child/create', data)
  }

  updateAdminTour (userId, IsLoginTourCompleted) {
    var data = { userId: userId, IsLoginTourCompleted: IsLoginTourCompleted }
    return axios.post(API_URL + '/update/login-tour', data)
  }

  bulkUploadMember (users) {
    return axios.post(API_URL + '/member/bulk-upload', users)
  }
}

export default new UserService()
